// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SearchBar_searchWrapper__bi9LF","searchIcon":"SearchBar_searchIcon__y6QPB","searchInput":"SearchBar_searchInput__EAZvr","clearSearch":"SearchBar_clearSearch__3x5VQ"};